import './DescriptionInput.scss';

import {
  CustomAmountDescriptionsFormData,
  amountKeys,
} from '../../../types/givingCheckoutForm';
import React, { FunctionComponent } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { ErrorMessage } from '@hookform/error-message';
import { useTranslation } from 'react-i18next';

type DescriptionInputProps = {
  id: number;
  label: string;
  onFocus?: () => void;
  onBlur?: () => void;
};

const DescriptionInput: FunctionComponent<DescriptionInputProps> = ({
  id,
  label,
  onFocus,
  onBlur,
}) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext<CustomAmountDescriptionsFormData>();
  const descriptionMaxLength = 70;

  const fieldName = `amount${id}` as amountKeys;
  const inputName = `amountDescriptions.${fieldName}` as const;

  const [fieldValueLive] = useWatch<
    CustomAmountDescriptionsFormData,
    [typeof inputName]
  >({
    name: [inputName],
  });
  const remainingCharacters =
    descriptionMaxLength - (fieldValueLive?.length ?? 0);

  return (
    <>
      <label
        className="jg-form-label jg-color--nero jg-space-mbxs"
        htmlFor={inputName}
      >
        {label}
      </label>
      <div className="description-input">
        <div className="description-input__remaining">
          {remainingCharacters}
        </div>

        <input
          className="jg-form-control description-input__form-control"
          type="text"
          id={inputName}
          placeholder={t(
            `customAmount.descriptions.placeholder${id as 1 | 2 | 3 | 4 | 5}`,
          )}
          maxLength={descriptionMaxLength}
          onFocus={onFocus}
          {...register(inputName, {
            required: {
              value: true,
              message: t('donationDescriptions.error.required'),
            },
            onBlur,
          })}
        />
        {Boolean(errors.amountDescriptions?.[fieldName]) && (
          <ErrorMessage
            errors={errors}
            name={inputName}
            render={({ message }) => {
              return (
                <p className="jg-form-error-copy" role="alert">
                  {message}
                </p>
              );
            }}
          />
        )}
      </div>
    </>
  );
};

export default DescriptionInput;
